/* eslint-disable */
import React from 'react'
import {Alert, Button, Form, Spinner} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useDispatch, useSelector} from 'react-redux'
import {
  digitalPlanetUpdateSettings,
  selectDigitalPlanetSettingsSaveLoading,
} from '../../../redux/slices/digitalplanetsettings.slice'

const validationSchema = Yup.object({
  webServiceUrl: Yup.string().required('WebService URL zorunludur.').url('Geçerli bir URL giriniz.'),
  username: Yup.string().required('Kullanıcı adı zorunludur.'),
  companyName: Yup.string().required('Firma adı zorunludur.'),
  password: Yup.string().min(4, 'Şifre en az 4 karakter olmalıdır.').optional(),
})

function EfaturaSettingsForm({settings}) {
  const dispatch = useDispatch()
  const saveLoading = useSelector(selectDigitalPlanetSettingsSaveLoading)
  const [saveSuccess, setSaveSuccess] = React.useState(false)
  const [saveError, setSaveError] = React.useState(null)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      webServiceUrl: settings?.webServiceUrl || '',
      username: settings?.username || '',
      companyName: settings?.companyName || '',
      password: '',
      isEnabled: settings?.isEnabled ?? false,
    },
    validationSchema,
    onSubmit: async (values) => {
      setSaveSuccess(false)
      setSaveError(null)
      const body = {
        webServiceUrl: values.webServiceUrl,
        username: values.username,
        companyName: values.companyName,
        isEnabled: values.isEnabled,
        ...(values.password ? {password: values.password} : {}),
      }
      try {
        await dispatch(digitalPlanetUpdateSettings(body)).unwrap()
        setSaveSuccess(true)
        formik.setFieldValue('password', '')
      } catch (err) {
        setSaveError(err?.message || 'Ayarlar kaydedilemedi.')
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      {saveSuccess && (
        <Alert variant='success' onClose={() => setSaveSuccess(false)} dismissible>
          Ayarlar başarıyla kaydedildi.
        </Alert>
      )}
      {saveError && (
        <Alert variant='danger' onClose={() => setSaveError(null)} dismissible>
          {saveError}
        </Alert>
      )}

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>WebService URL</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('webServiceUrl')}
          isInvalid={formik.touched.webServiceUrl && !!formik.errors.webServiceUrl}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.webServiceUrl}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>Kullanıcı Adı</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('username')}
          isInvalid={formik.touched.username && !!formik.errors.username}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.username}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold required'>Firma Adı</Form.Label>
        <Form.Control
          type='text'
          {...formik.getFieldProps('companyName')}
          isInvalid={formik.touched.companyName && !!formik.errors.companyName}
          disabled={saveLoading}
        />
        <Form.Control.Feedback type='invalid'>{formik.errors.companyName}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-5'>
        <Form.Label className='fw-bold'>
          Şifre{' '}
          <span className={`ms-2 small fw-normal ${settings?.passwordIsSet ? 'text-success' : 'text-warning'}`}>
            {settings?.passwordIsSet ? '✓ Şifre kayıtlı' : '⚠ Şifre girilmemiş'}
          </span>
        </Form.Label>
        <Form.Control
          type='password'
          placeholder='Değiştirmek istemiyorsanız boş bırakın'
          {...formik.getFieldProps('password')}
          isInvalid={formik.touched.password && !!formik.errors.password}
          disabled={saveLoading}
          autoComplete='new-password'
        />
        <Form.Text className='text-muted'>
          Boş bırakılırsa mevcut şifre korunur.
        </Form.Text>
        <Form.Control.Feedback type='invalid'>{formik.errors.password}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-8'>
        <Form.Check
          type='switch'
          id='isEnabled'
          label='Modülü Aktif Et'
          checked={formik.values.isEnabled}
          onChange={(e) => formik.setFieldValue('isEnabled', e.target.checked)}
          disabled={saveLoading}
        />
      </Form.Group>

      <Button type='submit' variant='primary' disabled={saveLoading}>
        {saveLoading ? (
          <>
            <Spinner animation='border' size='sm' className='me-2' />
            Kaydediliyor...
          </>
        ) : (
          'Kaydet'
        )}
      </Button>
    </form>
  )
}

export {EfaturaSettingsForm}
